export const fr = {
    clear: "Supprimer",
    today: "Aujourd'hui",
    now: "Maintenant",
    placeholders: {
        year: "AAAA",
        month: "AAAA-MM",
        date: "AAAA-MM-JJ",
        dateTime: "AAAA-MM-JJ hh:mm",
    },
};
//# sourceMappingURL=fr.js.map